export const isBannerText = (key: string): boolean => {
    var bannerTextFieldProperties = ["complianceText", "complianceBannerDescription", "breakingBannerDescription", "compliedBannerDescription", "featuredBannerDescription", "mandatoryBannerDescription", "publicBannerDescription", "restrictedBannerDescription"];
    return bannerTextFieldProperties.includes(key);
}